<div (click)="navigateToUrl(message.url)" *ngIf="message" class="info-container d-flex align-items-center c-pointer">
  <span class="message ms-3">{{ message?.content }}</span>
  <a *ngIf="message?.url && message?.textLink" class="ms-auto me-3" [href]="message?.url" target="_blank"
    ><button class="btn btn-primary btn-message">{{ message?.textLink }}</button></a
  >

  <i (click)="closeBanner()" class="fa fa-lg fa-times ms-auto me-3 close-btn" aria-hidden="true"></i>
</div>
